//  non-dynamic
import SGalleryLandingArtwork from "./SGalleryLandingArtwork_web"
export default SGalleryLandingArtwork
